export const COUNCIL_LIST = [
    { code: "Abrantes", name: "Abrantes" },
    { code: "Águeda", name: "Águeda" },
    { code: "Aguiar da Beira", name: "Aguiar da Beira" },
    { code: "Alandroal", name: "Alandroal" },
    { code: "Albergaria-a-Velha", name: "Albergaria-a-Velha" },
    { code: "Albufeira", name: "Albufeira" },
    { code: "Alcácer do Sal", name: "Alcácer do Sal" },
    { code: "Alcanena", name: "Alcanena" },
    { code: "Alcobaça", name: "Alcobaça" },
    { code: "Alcochete", name: "Alcochete" },
    { code: "Alcoutim", name: "Alcoutim" },
    { code: "Alenquer", name: "Alenquer" },
    { code: "Alfândega da Fé", name: "Alfândega da Fé" },
    { code: "Alijó", name: "Alijó" },
    { code: "Aljezur", name: "Aljezur" },
    { code: "Aljustrel", name: "Aljustrel" },
    { code: "Almada", name: "Almada" },
    { code: "Almeida", name: "Almeida" },
    { code: "Almeirim", name: "Almeirim" },
    { code: "Almodôvar", name: "Almodôvar" },
    { code: "Alpiarça", name: "Alpiarça" },
    { code: "Alter do Chão", name: "Alter do Chão" },
    { code: "Alvaiázere", name: "Alvaiázere" },
    { code: "Alvito", name: "Alvito" },
    { code: "Amadora", name: "Amadora" },
    { code: "Amarante", name: "Amarante" },
    { code: "Amares", name: "Amares" },
    { code: "Anadia", name: "Anadia" },
    { code: "Angra do Heroísmo", name: "Angra do Heroísmo" },
    { code: "Ansião", name: "Ansião" },
    { code: "Arcos de Valdevez", name: "Arcos de Valdevez" },
    { code: "Arganil", name: "Arganil" },
    { code: "Armamar", name: "Armamar" },
    { code: "Arouca", name: "Arouca" },
    { code: "Arraiolos", name: "Arraiolos" },
    { code: "Arronches", name: "Arronches" },
    { code: "Arruda dos Vinhos", name: "Arruda dos Vinhos" },
    { code: "Aveiro", name: "Aveiro" },
    { code: "Avis", name: "Avis" },
    { code: "Azambuja", name: "Azambuja" },
    { code: "Baião", name: "Baião" },
    { code: "Barcelos", name: "Barcelos" },
    { code: "Barrancos", name: "Barrancos" },
    { code: "Barreiro", name: "Barreiro" },
    { code: "Batalha", name: "Batalha" },
    { code: "Beja", name: "Beja" },
    { code: "Belmonte", name: "Belmonte" },
    { code: "Benavente", name: "Benavente" },
    { code: "Bombarral", name: "Bombarral" },
    { code: "Borba", name: "Borba" },
    { code: "Boticas", name: "Boticas" },
    { code: "Braga", name: "Braga" },
    { code: "Bragança", name: "Bragança" },
    { code: "Cabeceiras de Basto", name: "Cabeceiras de Basto" },
    { code: "Cadaval", name: "Cadaval" },
    { code: "Caldas da Rainha", name: "Caldas da Rainha" },
    { code: "Calheta (Madeira)", name: "Calheta (Madeira)" },
    { code: "Calheta (São Jorge)", name: "Calheta (São Jorge)" },
    { code: "Caminha", name: "Caminha" },
    { code: "Campo Maior", name: "Campo Maior" },
    { code: "Cantanhede", name: "Cantanhede" },
    { code: "Carrazeda de Ansiães", name: "Carrazeda de Ansiães" },
    { code: "Carregal do Sal", name: "Carregal do Sal" },
    { code: "Cartaxo", name: "Cartaxo" },
    { code: "Cascais", name: "Cascais" },
    { code: "Castanheira de Pêra", name: "Castanheira de Pêra" },
    { code: "Castelo Branco", name: "Castelo Branco" },
    { code: "Castelo de Paiva", name: "Castelo de Paiva" },
    { code: "Castelo de Vide", name: "Castelo de Vide" },
    { code: "Castro Daire", name: "Castro Daire" },
    { code: "Castro Marim", name: "Castro Marim" },
    { code: "Castro Verde", name: "Castro Verde" },
    { code: "Celorico da Beira", name: "Celorico da Beira" },
    { code: "Celorico de Basto", name: "Celorico de Basto" },
    { code: "Chamusca", name: "Chamusca" },
    { code: "Chaves", name: "Chaves" },
    { code: "Cinfães", name: "Cinfães" },
    { code: "Coimbra", name: "Coimbra" },
    { code: "Condeixa-a-Nova", name: "Condeixa-a-Nova" },
    { code: "Constância", name: "Constância" },
    { code: "Coruche", name: "Coruche" },
    { code: "Corvo", name: "Corvo" },
    { code: "Covilhã", name: "Covilhã" },
    { code: "Crato", name: "Crato" },
    { code: "Cuba", name: "Cuba" },
    { code: "Câmara de Lobos", name: "Câmara de Lobos" },
    { code: "Elvas", name: "Elvas" },
    { code: "Entroncamento", name: "Entroncamento" },
    { code: "Espinho", name: "Espinho" },
    { code: "Esposende", name: "Esposende" },
    { code: "Estarreja", name: "Estarreja" },
    { code: "Estremoz", name: "Estremoz" },
    { code: "Évora", name: "Évora" },
    { code: "Fafe", name: "Fafe" },
    { code: "Faro", name: "Faro" },
    { code: "Felgueiras", name: "Felgueiras" },
    { code: "Ferreira do Alentejo", name: "Ferreira do Alentejo" },
    { code: "Ferreira do Zêzere", name: "Ferreira do Zêzere" },
    { code: "Figueira da Foz", name: "Figueira da Foz" },
    { code: "Figueira de Castelo Rodrigo", name: "Figueira de Castelo Rodrigo" },
    { code: "Figueiró dos Vinhos", name: "Figueiró dos Vinhos" },
    { code: "Fornos de Algodres", name: "Fornos de Algodres" },
    { code: "Freixo de Espada à Cinta", name: "Freixo de Espada à Cinta" },
    { code: "Fronteira", name: "Fronteira" },
    { code: "Funchal", name: "Funchal" },
    { code: "Fundão", name: "Fundão" },
    { code: "Gavião", name: "Gavião" },
    { code: "Golegã", name: "Golegã" },
    { code: "Gondomar", name: "Gondomar" },
    { code: "Gouveia", name: "Gouveia" },
    { code: "Grândola", name: "Grândola" },
    { code: "Guarda", name: "Guarda" },
    { code: "Guimarães", name: "Guimarães" },
    { code: "Góis", name: "Góis" },
    { code: "Horta", name: "Horta" },
    { code: "Idanha-a-Nova", name: "Idanha-a-Nova" },
    { code: "Ílhavo", name: "Ílhavo" },
    { code: "Lagoa (Algarve)", name: "Lagoa (Algarve)" },
    { code: "Lagoa (São Miguel)", name: "Lagoa (São Miguel)" },
    { code: "Lagos", name: "Lagos" },
    { code: "Lajes das Flores", name: "Lajes das Flores" },
    { code: "Lajes do Pico", name: "Lajes do Pico" },
    { code: "Lamego", name: "Lamego" },
    { code: "Leiria", name: "Leiria" },
    { code: "Lisboa", name: "Lisboa" },
    { code: "Loulé", name: "Loulé" },
    { code: "Loures", name: "Loures" },
    { code: "Lourinhã", name: "Lourinhã" },
    { code: "Lousã", name: "Lousã" },
    { code: "Lousada", name: "Lousada" },
    { code: "Mação", name: "Mação" },
    { code: "Macedo de Cavaleiros", name: "Macedo de Cavaleiros" },
    { code: "Machico", name: "Machico" },
    { code: "Madalena", name: "Madalena" },
    { code: "Mafra", name: "Mafra" },
    { code: "Maia", name: "Maia" },
    { code: "Mangualde", name: "Mangualde" },
    { code: "Manteigas", name: "Manteigas" },
    { code: "Marco de Canaveses", name: "Marco de Canaveses" },
    { code: "Marinha Grande", name: "Marinha Grande" },
    { code: "Marvão", name: "Marvão" },
    { code: "Matosinhos", name: "Matosinhos" },
    { code: "Mealhada", name: "Mealhada" },
    { code: "Meda", name: "Meda" },
    { code: "Melgaço", name: "Melgaço" },
    { code: "Mesão Frio", name: "Mesão Frio" },
    { code: "Mira", name: "Mira" },
    { code: "Miranda do Corvo", name: "Miranda do Corvo" },
    { code: "Miranda do Douro", name: "Miranda do Douro" },
    { code: "Mirandela", name: "Mirandela" },
    { code: "Mogadouro", name: "Mogadouro" },
    { code: "Moimenta da Beira", name: "Moimenta da Beira" },
    { code: "Moita", name: "Moita" },
    { code: "Monção", name: "Monção" },
    { code: "Monchique", name: "Monchique" },
    { code: "Mondim de Basto", name: "Mondim de Basto" },
    { code: "Monforte", name: "Monforte" },
    { code: "Montalegre", name: "Montalegre" },
    { code: "Montemor-o-Novo", name: "Montemor-o-Novo" },
    { code: "Montemor-o-Velho", name: "Montemor-o-Velho" },
    { code: "Montijo", name: "Montijo" },
    { code: "Mora", name: "Mora" },
    { code: "Mortágua", name: "Mortágua" },
    { code: "Moura", name: "Moura" },
    { code: "Mourão", name: "Mourão" },
    { code: "Murça", name: "Murça" },
    { code: "Murtosa", name: "Murtosa" },
    { code: "Mértola", name: "Mértola" },
    { code: "Nazaré", name: "Nazaré" },
    { code: "Nelas", name: "Nelas" },
    { code: "Nisa", name: "Nisa" },
    { code: "Nordeste", name: "Nordeste" },
    { code: "Óbidos", name: "Óbidos" },
    { code: "Odemira", name: "Odemira" },
    { code: "Odivelas", name: "Odivelas" },
    { code: "Oeiras", name: "Oeiras" },
    { code: "Oleiros", name: "Oleiros" },
    { code: "Olhão", name: "Olhão" },
    { code: "Oliveira de Azeméis", name: "Oliveira de Azeméis" },
    { code: "Oliveira de Frades", name: "Oliveira de Frades" },
    { code: "Oliveira do Bairro", name: "Oliveira do Bairro" },
    { code: "Oliveira do Hospital", name: "Oliveira do Hospital" },
    { code: "Ourique", name: "Ourique" },
    { code: "Ourém", name: "Ourém" },
    { code: "Ovar", name: "Ovar" },
    { code: "Paços de Ferreira", name: "Paços de Ferreira" },
    { code: "Palmela", name: "Palmela" },
    { code: "Pampilhosa da Serra", name: "Pampilhosa da Serra" },
    { code: "Paredes", name: "Paredes" },
    { code: "Paredes de Coura", name: "Paredes de Coura" },
    { code: "Pedrógão Grande", name: "Pedrógão Grande" },
    { code: "Penacova", name: "Penacova" },
    { code: "Penafiel", name: "Penafiel" },
    { code: "Penalva do Castelo", name: "Penalva do Castelo" },
    { code: "Penamacor", name: "Penamacor" },
    { code: "Penedono", name: "Penedono" },
    { code: "Penela", name: "Penela" },
    { code: "Peniche", name: "Peniche" },
    { code: "Peso da Régua", name: "Peso da Régua" },
    { code: "Pinhel", name: "Pinhel" },
    { code: "Pombal", name: "Pombal" },
    { code: "Ponta Delgada", name: "Ponta Delgada" },
    { code: "Ponta do Sol", name: "Ponta do Sol" },
    { code: "Ponte da Barca", name: "Ponte da Barca" },
    { code: "Ponte de Lima", name: "Ponte de Lima" },
    { code: "Ponte de Sor", name: "Ponte de Sor" },
    { code: "Portalegre", name: "Portalegre" },
    { code: "Portel", name: "Portel" },
    { code: "Portimão", name: "Portimão" },
    { code: "Porto", name: "Porto" },
    { code: "Porto Moniz", name: "Porto Moniz" },
    { code: "Porto Santo", name: "Porto Santo" },
    { code: "Porto de Mós", name: "Porto de Mós" },
    { code: "Povoação", name: "Povoação" },
    { code: "Praia da Vitória", name: "Praia da Vitória" },
    { code: "Proença-a-Nova", name: "Proença-a-Nova" },
    { code: "Póvoa de Lanhoso", name: "Póvoa de Lanhoso" },
    { code: "Póvoa de Varzim", name: "Póvoa de Varzim" },
    { code: "Redondo", name: "Redondo" },
    { code: "Reguengos de Monsaraz", name: "Reguengos de Monsaraz" },
    { code: "Resende", name: "Resende" },
    { code: "Ribeira Brava", name: "Ribeira Brava" },
    { code: "Ribeira Grande", name: "Ribeira Grande" },
    { code: "Ribeira de Pena", name: "Ribeira de Pena" },
    { code: "Rio Maior", name: "Rio Maior" },
    { code: "Sabrosa", name: "Sabrosa" },
    { code: "Sabugal", name: "Sabugal" },
    { code: "Salvaterra de Magos", name: "Salvaterra de Magos" },
    { code: "Santa Comba Dão", name: "Santa Comba Dão" },
    { code: "Santa Cruz", name: "Santa Cruz" },
    { code: "Santa Cruz da Graciosa", name: "Santa Cruz da Graciosa" },
    { code: "Santa Cruz das Flores", name: "Santa Cruz das Flores" },
    { code: "Santa Maria da Feira", name: "Santa Maria da Feira" },
    { code: "Santa Marta de Penaguião", name: "Santa Marta de Penaguião" },
    { code: "Santana", name: "Santana" },
    { code: "Santarém", name: "Santarém" },
    { code: "Santiago do Cacém", name: "Santiago do Cacém" },
    { code: "Santo Tirso", name: "Santo Tirso" },
    { code: "São Brás de Alportel", name: "São Brás de Alportel" },
    { code: "São João da Madeira", name: "São João da Madeira" },
    { code: "São João da Pesqueira", name: "São João da Pesqueira" },
    { code: "São Pedro do Sul", name: "São Pedro do Sul" },
    { code: "São Roque do Pico", name: "São Roque do Pico" },
    { code: "São Vicente", name: "São Vicente" },
    { code: "Sardoal", name: "Sardoal" },
    { code: "Sátão", name: "Sátão" },
    { code: "Seia", name: "Seia" },
    { code: "Seixal", name: "Seixal" },
    { code: "Sernancelhe", name: "Sernancelhe" },
    { code: "Serpa", name: "Serpa" },
    { code: "Sertã", name: "Sertã" },
    { code: "Sesimbra", name: "Sesimbra" },
    { code: "Setúbal", name: "Setúbal" },
    { code: "Sever do Vouga", name: "Sever do Vouga" },
    { code: "Silves", name: "Silves" },
    { code: "Sines", name: "Sines" },
    { code: "Sintra", name: "Sintra" },
    { code: "Sobral de Monte Agraço", name: "Sobral de Monte Agraço" },
    { code: "Soure", name: "Soure" },
    { code: "Sousel", name: "Sousel" },
    { code: "Tábua", name: "Tábua" },
    { code: "Tabuaço", name: "Tabuaço" },
    { code: "Tarouca", name: "Tarouca" },
    { code: "Tavira", name: "Tavira" },
    { code: "Terras de Bouro", name: "Terras de Bouro" },
    { code: "Tomar", name: "Tomar" },
    { code: "Tondela", name: "Tondela" },
    { code: "Torre de Moncorvo", name: "Torre de Moncorvo" },
    { code: "Torres Novas", name: "Torres Novas" },
    { code: "Torres Vedras", name: "Torres Vedras" },
    { code: "Trancoso", name: "Trancoso" },
    { code: "Trofa", name: "Trofa" },
    { code: "Vagos", name: "Vagos" },
    { code: "Vale de Cambra", name: "Vale de Cambra" },
    { code: "Valença", name: "Valença" },
    { code: "Valongo", name: "Valongo" },
    { code: "Valpaços", name: "Valpaços" },
    { code: "Velas", name: "Velas" },
    { code: "Vendas Novas", name: "Vendas Novas" },
    { code: "Viana do Alentejo", name: "Viana do Alentejo" },
    { code: "Viana do Castelo", name: "Viana do Castelo" },
    { code: "Vidigueira", name: "Vidigueira" },
    { code: "Vieira do Minho", name: "Vieira do Minho" },
    { code: "Vila Flor", name: "Vila Flor" },
    { code: "Vila Franca de Xira", name: "Vila Franca de Xira" },
    { code: "Vila Franca do Campo", name: "Vila Franca do Campo" },
    { code: "Vila Nova da Barquinha", name: "Vila Nova da Barquinha" },
    { code: "Vila Nova de Cerveira", name: "Vila Nova de Cerveira" },
    { code: "Vila Nova de Famalicão", name: "Vila Nova de Famalicão" },
    { code: "Vila Nova de Foz Côa", name: "Vila Nova de Foz Côa" },
    { code: "Vila Nova de Gaia", name: "Vila Nova de Gaia" },
    { code: "Vila Nova de Paiva", name: "Vila Nova de Paiva" },
    { code: "Vila Nova de Poiares", name: "Vila Nova de Poiares" },
    { code: "Vila Pouca de Aguiar", name: "Vila Pouca de Aguiar" },
    { code: "Vila Real", name: "Vila Real" },
    { code: "Vila Real de Santo António", name: "Vila Real de Santo António" },
    { code: "Vila Velha de Ródão", name: "Vila Velha de Ródão" },
    { code: "Vila Verde", name: "Vila Verde" },
    { code: "Vila Viçosa", name: "Vila Viçosa" },
    { code: "Vila de Rei", name: "Vila de Rei" },
    { code: "Vila do Bispo", name: "Vila do Bispo" },
    { code: "Vila do Conde", name: "Vila do Conde" },
    { code: "Vila do Porto", name: "Vila do Porto" },
    { code: "Vimioso", name: "Vimioso" },
    { code: "Vinhais", name: "Vinhais" },
    { code: "Viseu", name: "Viseu" },
    { code: "Vizela", name: "Vizela" },
    { code: "Vouzela", name: "Vouzela" }
];

export const DISTRICT_LIST = [
    { code: "Aveiro", name: "Aveiro" },
    { code: "Beja", name: "Beja" },
    { code: "Braga", name: "Braga" },
    { code: "Bragança", name: "Bragança" },
    { code: "Castelo Branco", name: "Castelo Branco" },
    { code: "Coimbra", name: "Coimbra" },
    { code: "Évora", name: "Évora" },
    { code: "Faro", name: "Faro" },
    { code: "Guarda", name: "Guarda" },
    { code: "Leiria", name: "Leiria" },
    { code: "Lisboa", name: "Lisboa" },
    { code: "Portalegre", name: "Portalegre" },
    { code: "Porto", name: "Porto" },
    { code: "Santarém", name: "Santarém" },
    { code: "Setúbal", name: "Setúbal" },
    { code: "Viana do Castelo", name: "Viana do Castelo" },
    { code: "Vila Real", name: "Vila Real" },
    { code: "Viseu", name: "Viseu" },
    { code: "Ilha da Madeira", name: "Ilha da Madeira" },
    { code: "Ilha de Porto Santo", name: "Ilha de Porto Santo" },
    { code: "Ilha de Santa Maria", name: "Ilha de Santa Maria" },
    { code: "Ilha de São Miguel", name: "Ilha de São Miguel" },
    { code: "Ilha Terceira", name: "Ilha Terceira" },
    { code: "Ilha da Graciosa", name: "Ilha da Graciosa" },
    { code: "Ilha de São Jorge", name: "Ilha de São Jorge" },
    { code: "Ilha do Pico", name: "Ilha do Pico" },
    { code: "Ilha do Faial", name: "Ilha do Faial" },
    { code: "Ilha das Flores", name: "Ilha das Flores" },
    { code: "Ilha do Corvo", name: "Ilha do Corvo" }
];

export const DCF_LIST = [
    { council: "Abrantes", district: "Santarém" },
    { council: "Águeda", district: "Aveiro" },
    { council: "Aguiar da Beira", district: "Guarda" },
    { council: "Alandroal", district: "Évora" },
    { council: "Albergaria-a-Velha", district: "Aveiro" },
    { council: "Albufeira", district: "Faro" },
    { council: "Alcácer do Sal", district: "Setúbal" },
    { council: "Alcanena", district: "Santarém" },
    { council: "Alcobaça", district: "Leiria" },
    { council: "Alcochete", district: "Setúbal" },
    { council: "Alcoutim", district: "Faro" },
    { council: "Alenquer", district: "Lisboa" },
    { council: "Alfândega da Fé", district: "Bragança" },
    { council: "Alijó", district: "Vila Real" },
    { council: "Aljezur", district: "Faro" },
    { council: "Aljustrel", district: "Beja" },
    { council: "Almada", district: "Setúbal" },
    { council: "Almeida", district: "Guarda" },
    { council: "Almeirim", district: "Santarém" },
    { council: "Almodôvar", district: "Beja" },
    { council: "Alpiarça", district: "Santarém" },
    { council: "Alter do Chão", district: "Portalegre" },
    { council: "Alvaiázere", district: "Leiria" },
    { council: "Alvito", district: "Beja" },
    { council: "Amadora", district: "Lisboa" },
    { council: "Amarante", district: "Porto" },
    { council: "Amares", district: "Braga" },
    { council: "Anadia", district: "Aveiro" },
    { council: "Angra do Heroísmo", district: "Ilha Terceira" },
    { council: "Ansião", district: "Leiria" },
    { council: "Arcos de Valdevez", district: "Viana do Castelo" },
    { council: "Arganil", district: "Coimbra" },
    { council: "Armamar", district: "Viseu" },
    { council: "Arouca", district: "Aveiro" },
    { council: "Arraiolos", district: "Évora" },
    { council: "Arronches", district: "Portalegre" },
    { council: "Arruda dos Vinhos", district: "Lisboa" },
    { council: "Aveiro", district: "Aveiro" },
    { council: "Avis", district: "Portalegre" },
    { council: "Azambuja", district: "Lisboa" },
    { council: "Baião", district: "Porto" },
    { council: "Barcelos", district: "Braga" },
    { council: "Barrancos", district: "Beja" },
    { council: "Barreiro", district: "Setúbal" },
    { council: "Batalha", district: "Leiria" },
    { council: "Beja", district: "Beja" },
    { council: "Belmonte", district: "Castelo Branco" },
    { council: "Benavente", district: "Santarém" },
    { council: "Bombarral", district: "Leiria" },
    { council: "Borba", district: "Évora" },
    { council: "Boticas", district: "Vila Real" },
    { council: "Braga", district: "Braga" },
    { council: "Bragança", district: "Bragança" },
    { council: "Cabeceiras de Basto", district: "Braga" },
    { council: "Cadaval", district: "Lisboa" },
    { council: "Caldas da Rainha", district: "Leiria" },
    { council: "Calheta (Madeira)", district: "Ilha da Madeira" },
    { council: "Calheta (São Jorge)", district: "Ilha de São Jorge" },
    { council: "Caminha", district: "Viana do Castelo" },
    { council: "Campo Maior", district: "Portalegre" },
    { council: "Cantanhede", district: "Coimbra" },
    { council: "Carrazeda de Ansiães", district: "Bragança" },
    { council: "Carregal do Sal", district: "Viseu" },
    { council: "Cartaxo", district: "Santarém" },
    { council: "Cascais", district: "Lisboa" },
    { council: "Castanheira de Pêra", district: "Leiria" },
    { council: "Castelo Branco", district: "Castelo Branco" },
    { council: "Castelo de Paiva", district: "Aveiro" },
    { council: "Castelo de Vide", district: "Portalegre" },
    { council: "Castro Daire", district: "Viseu" },
    { council: "Castro Marim", district: "Faro" },
    { council: "Castro Verde", district: "Beja" },
    { council: "Celorico da Beira", district: "Guarda" },
    { council: "Celorico de Basto", district: "Braga" },
    { council: "Chamusca", district: "Santarém" },
    { council: "Chaves", district: "Vila Real" },
    { council: "Cinfães", district: "Viseu" },
    { council: "Coimbra", district: "Coimbra" },
    { council: "Condeixa-a-Nova", district: "Coimbra" },
    { council: "Constância", district: "Santarém" },
    { council: "Coruche", district: "Santarém" },
    { council: "Corvo", district: "Ilha do Corvo" },
    { council: "Covilhã", district: "Castelo Branco" },
    { council: "Crato", district: "Portalegre" },
    { council: "Cuba", district: "Beja" },
    { council: "Câmara de Lobos", district: "Ilha da Madeira" },
    { council: "Elvas", district: "Portalegre" },
    { council: "Entroncamento", district: "Santarém" },
    { council: "Espinho", district: "Aveiro" },
    { council: "Esposende", district: "Braga" },
    { council: "Estarreja", district: "Aveiro" },
    { council: "Estremoz", district: "Évora" },
    { council: "Évora", district: "Évora" },
    { council: "Fafe", district: "Braga" },
    { council: "Faro", district: "Faro" },
    { council: "Felgueiras", district: "Porto" },
    { council: "Ferreira do Alentejo", district: "Beja" },
    { council: "Ferreira do Zêzere", district: "Santarém" },
    { council: "Figueira da Foz", district: "Coimbra" },
    { council: "Figueira de Castelo Rodrigo", district: "Guarda" },
    { council: "Figueiró dos Vinhos", district: "Leiria" },
    { council: "Fornos de Algodres", district: "Guarda" },
    { council: "Freixo de Espada à Cinta", district: "Bragança" },
    { council: "Fronteira", district: "Portalegre" },
    { council: "Funchal", district: "Ilha da Madeira" },
    { council: "Fundão", district: "Castelo Branco" },
    { council: "Gavião", district: "Portalegre" },
    { council: "Golegã", district: "Santarém" },
    { council: "Gondomar", district: "Porto" },
    { council: "Gouveia", district: "Guarda" },
    { council: "Grândola", district: "Setúbal" },
    { council: "Guarda", district: "Guarda" },
    { council: "Guimarães", district: "Braga" },
    { council: "Góis", district: "Coimbra" },
    { council: "Horta", district: "Ilha do Faial" },
    { council: "Idanha-a-Nova", district: "Castelo Branco" },
    { council: "Ílhavo", district: "Aveiro" },
    { council: "Lagoa (Algarve)", district: "Faro" },
    { council: "Lagoa (São Miguel)", district: "Ilha de São Miguel" },
    { council: "Lagos", district: "Faro" },
    { council: "Lajes das Flores", district: "Ilha das Flores" },
    { council: "Lajes do Pico", district: "Ilha do Pico" },
    { council: "Lamego", district: "Viseu" },
    { council: "Leiria", district: "Leiria" },
    { council: "Lisboa", district: "Lisboa" },
    { council: "Loulé", district: "Faro" },
    { council: "Loures", district: "Lisboa" },
    { council: "Lourinhã", district: "Lisboa" },
    { council: "Lousã", district: "Coimbra" },
    { council: "Lousada", district: "Porto" },
    { council: "Mação", district: "Santarém" },
    { council: "Macedo de Cavaleiros", district: "Bragança" },
    { council: "Machico", district: "Ilha da Madeira" },
    { council: "Madalena", district: "Ilha do Pico" },
    { council: "Mafra", district: "Lisboa" },
    { council: "Maia", district: "Porto" },
    { council: "Mangualde", district: "Viseu" },
    { council: "Manteigas", district: "Guarda" },
    { council: "Marco de Canaveses", district: "Porto" },
    { council: "Marinha Grande", district: "Leiria" },
    { council: "Marvão", district: "Portalegre" },
    { council: "Matosinhos", district: "Porto" },
    { council: "Mealhada", district: "Aveiro" },
    { council: "Meda", district: "Guarda" },
    { council: "Melgaço", district: "Viana do Castelo" },
    { council: "Mesão Frio", district: "Vila Real" },
    { council: "Mira", district: "Coimbra" },
    { council: "Miranda do Corvo", district: "Coimbra" },
    { council: "Miranda do Douro", district: "Bragança" },
    { council: "Mirandela", district: "Bragança" },
    { council: "Mogadouro", district: "Bragança" },
    { council: "Moimenta da Beira", district: "Viseu" },
    { council: "Moita", district: "Setúbal" },
    { council: "Monção", district: "Viana do Castelo" },
    { council: "Monchique", district: "Faro" },
    { council: "Mondim de Basto", district: "Vila Real" },
    { council: "Monforte", district: "Portalegre" },
    { council: "Montalegre", district: "Vila Real" },
    { council: "Montemor-o-Novo", district: "Évora" },
    { council: "Montemor-o-Velho", district: "Coimbra" },
    { council: "Montijo", district: "Setúbal" },
    { council: "Mora", district: "Évora" },
    { council: "Mortágua", district: "Viseu" },
    { council: "Moura", district: "Beja" },
    { council: "Mourão", district: "Évora" },
    { council: "Murça", district: "Vila Real" },
    { council: "Murtosa", district: "Aveiro" },
    { council: "Mértola", district: "Beja" },
    { council: "Nazaré", district: "Leiria" },
    { council: "Nelas", district: "Viseu" },
    { council: "Nisa", district: "Portalegre" },
    { council: "Nordeste", district: "Ilha de São Miguel" },
    { council: "Óbidos", district: "Leiria" },
    { council: "Odemira", district: "Beja" },
    { council: "Odivelas", district: "Lisboa" },
    { council: "Oeiras", district: "Lisboa" },
    { council: "Oleiros", district: "Castelo Branco" },
    { council: "Olhão", district: "Faro" },
    { council: "Oliveira de Azeméis", district: "Aveiro" },
    { council: "Oliveira de Frades", district: "Viseu" },
    { council: "Oliveira do Bairro", district: "Aveiro" },
    { council: "Oliveira do Hospital", district: "Coimbra" },
    { council: "Ourique", district: "Beja" },
    { council: "Ourém", district: "Santarém" },
    { council: "Ovar", district: "Aveiro" },
    { council: "Paços de Ferreira", district: "Porto" },
    { council: "Palmela", district: "Setúbal" },
    { council: "Pampilhosa da Serra", district: "Coimbra" },
    { council: "Paredes", district: "Porto" },
    { council: "Paredes de Coura", district: "Viana do Castelo" },
    { council: "Pedrógão Grande", district: "Leiria" },
    { council: "Penacova", district: "Coimbra" },
    { council: "Penafiel", district: "Porto" },
    { council: "Penalva do Castelo", district: "Viseu" },
    { council: "Penamacor", district: "Castelo Branco" },
    { council: "Penedono", district: "Viseu" },
    { council: "Penela", district: "Coimbra" },
    { council: "Peniche", district: "Leiria" },
    { council: "Peso da Régua", district: "Vila Real" },
    { council: "Pinhel", district: "Guarda" },
    { council: "Pombal", district: "Leiria" },
    { council: "Ponta Delgada", district: "Ilha de São Miguel" },
    { council: "Ponta do Sol", district: "Ilha da Madeira" },
    { council: "Ponte da Barca", district: "Viana do Castelo" },
    { council: "Ponte de Lima", district: "Viana do Castelo" },
    { council: "Ponte de Sor", district: "Portalegre" },
    { council: "Portalegre", district: "Portalegre" },
    { council: "Portel", district: "Évora" },
    { council: "Portimão", district: "Faro" },
    { council: "Porto", district: "Porto" },
    { council: "Porto Moniz", district: "Ilha da Madeira" },
    { council: "Porto Santo", district: "Ilha da Madeira" },
    { council: "Porto de Mós", district: "Leiria" },
    { council: "Povoação", district: "Ilha de São Miguel" },
    { council: "Praia da Vitória", district: "Praia da Vitória" },
    { council: "Proença-a-Nova", district: "Castelo Branco" },
    { council: "Póvoa de Lanhoso", district: "Braga" },
    { council: "Póvoa de Varzim", district: "Porto" },
    { council: "Redondo", district: "Évora" },
    { council: "Reguengos de Monsaraz", district: "Évora" },
    { council: "Resende", district: "Viseu" },
    { council: "Ribeira Brava", district: "Ilha da Madeira" },
    { council: "Ribeira Grande", district: "Ilha de São Miguel" },
    { council: "Ribeira de Pena", district: "Vila Real" },
    { council: "Rio Maior", district: "Santarém" },
    { council: "Sabrosa", district: "Vila Real" },
    { council: "Sabugal", district: "Guarda" },
    { council: "Salvaterra de Magos", district: "Santarém" },
    { council: "Santa Comba Dão", district: "Viseu" },
    { council: "Santa Cruz", district: "Ilha da Madeira" },
    { council: "Santa Cruz da Graciosa", district: "Ilha da Graciosa" },
    { council: "Santa Cruz das Flores", district: "Ilha das Flores" },
    { council: "Santa Maria da Feira", district: "Aveiro" },
    { council: "Santa Marta de Penaguião", district: "Vila Real" },
    { council: "Santana", district: "Ilha da Madeira" },
    { council: "Santarém", district: "Santarém" },
    { council: "Santiago do Cacém", district: "Setúbal" },
    { council: "Santo Tirso", district: "Porto" },
    { council: "São Brás de Alportel", district: "Faro" },
    { council: "São João da Madeira", district: "Aveiro" },
    { council: "São João da Pesqueira", district: "Viseu" },
    { council: "São Pedro do Sul", district: "Viseu" },
    { council: "São Roque do Pico", district: "Ilha do Pico" },
    { council: "São Vicente", district: "Ilha da Madeira" },
    { council: "Sardoal", district: "Santarém" },
    { council: "Sátão", district: "Viseu" },
    { council: "Seia", district: "Guarda" },
    { council: "Seixal", district: "Setúbal" },
    { council: "Sernancelhe", district: "Viseu" },
    { council: "Serpa", district: "Beja" },
    { council: "Sertã", district: "Castelo Branco" },
    { council: "Sesimbra", district: "Setúbal" },
    { council: "Setúbal", district: "Setúbal" },
    { council: "Sever do Vouga", district: "Aveiro" },
    { council: "Silves", district: "Faro" },
    { council: "Sines", district: "Setúbal" },
    { council: "Sintra", district: "Lisboa" },
    { council: "Sobral de Monte Agraço", district: "Lisboa" },
    { council: "Soure", district: "Coimbra" },
    { council: "Sousel", district: "Portalegre" },
    { council: "Tábua", district: "Coimbra" },
    { council: "Tabuaço", district: "Viseu" },
    { council: "Tarouca", district: "Tarouca" },
    { council: "Tavira", district: "Faro" },
    { council: "Terras de Bouro", district: "Braga" },
    { council: "Tomar", district: "Santarém" },
    { council: "Tondela", district: "Viseu" },
    { council: "Torre de Moncorvo", district: "Bragança" },
    { council: "Torres Novas", district: "Santarém" },
    { council: "Torres Vedras", district: "Lisboa" },
    { council: "Trancoso", district: "Guarda" },
    { council: "Trofa", district: "Porto" },
    { council: "Vagos", district: "Aveiro" },
    { council: "Vale de Cambra", district: "Aveiro" },
    { council: "Valença", district: "Viana do Castelo" },
    { council: "Valongo", district: "Porto" },
    { council: "Valpaços", district: "Vila Real" },
    { council: "Velas", district: "Ilha de São Jorge" },
    { council: "Vendas Novas", district: "Évora" },
    { council: "Viana do Alentejo", district: "Évora" },
    { council: "Viana do Castelo", district: "Viana do Castelo" },
    { council: "Vidigueira", district: "Beja" },
    { council: "Vieira do Minho", district: "Braga" },
    { council: "Vila Flor", district: "Bragança" },
    { council: "Vila Franca de Xira", district: "Lisboa" },
    { council: "Vila Franca do Campo", district: "Ilha de São Miguel" },
    { council: "Vila Nova da Barquinha", district: "Santarém" },
    { council: "Vila Nova de Cerveira", district: "Viana do Castelo" },
    { council: "Vila Nova de Famalicão", district: "Braga" },
    { council: "Vila Nova de Foz Côa", district: "Guarda" },
    { council: "Vila Nova de Gaia", district: "Porto" },
    { council: "Vila Nova de Paiva", district: "Viseu" },
    { council: "Vila Nova de Poiares", district: "Coimbra" },
    { council: "Vila Pouca de Aguiar", district: "Vila Real" },
    { council: "Vila Real", district: "Vila Real" },
    { council: "Vila Real de Santo António", district: "Faro" },
    { council: "Vila Velha de Ródão", district: "Castelo Branco" },
    { council: "Vila Verde", district: "Braga" },
    { council: "Vila Viçosa", district: "Évora" },
    { council: "Vila de Rei", district: "Castelo Branco" },
    { council: "Vila do Bispo", district: "Faro" },
    { council: "Vila do Conde", district: "Porto" },
    { council: "Vila do Porto", district: "Ilha de Santa Maria" },
    { council: "Vimioso", district: "Bragança" },
    { council: "Vinhais", district: "Bragança" },
    { council: "Viseu", district: "Viseu" },
    { council: "Vizela", district: "Braga" },
    { council: "Vouzela", district: "Viseu" }
];